const Comments = {};

{
    const _changePalletHyvorTalk = () => {
        if (!window.hyvorTalk || !window.hyvor_talk) return;
        if (currentTheme === 'dark') {
            window.hyvorTalk.currentPalette = window.hyvorTalk.palettes.dark;
        } else {
            window.hyvorTalk.currentPalette = window.hyvorTalk.palettes.light;
        }
        hyvor_talk && hyvor_talk.setPalette && hyvor_talk.setPalette(window.hyvorTalk.currentPalette);
    };

    Comments.init = () => {
        _changePalletHyvorTalk();
    };

    Comments.changePalletHyvorTalk = _changePalletHyvorTalk;
}